{
  "columnResizer": "Засіб змінення розміру стовпця",
  "loading": "Завантаження…",
  "loadingMore": "Завантаження інших об’єктів...",
  "resizeColumn": "Змінити розмір стовпця",
  "sortAscending": "Сортувати за зростанням",
  "sortDescending": "Сортувати за спаданням"
}
